import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import LegalModal from '../../../components/LegalModal';
import { TermsOfService, PrivacyPolicy } from '../../../legal/LegalTexts';

const TrustIndicators = () => {
  const [modalType, setModalType] = useState(null);

  const indicators = [
    {
      id: 'compliance',
      icon: 'CheckCircle2',
      text: 'Conformidade LGPD',
      description: '',
    },
    {
      id: 'aws',
      icon: 'Cloud',
      text: 'Infraestrutura 100% AWS',
      description: '',
    },
    {
      id: 'mercadopago',
      icon: 'CreditCard',
      text: 'Pagamentos via Mercado Pago',
      description: '',
    },
  ];

  return (
    <>
      {/* TRUST INDICATORS */}
      <div className="mt-8 lg:mt-10 pt-6 lg:pt-8 border-t border-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {indicators.map((indicator) => (
            <div
              key={indicator.id}
              className="flex items-start space-x-3 p-4 rounded-lg bg-muted/30 transition-smooth hover:bg-muted/50"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-success/10 rounded-lg">
                <Icon
                  name={indicator.icon}
                  size={20}
                  color="var(--color-success)"
                />
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground">
                  {indicator.text}
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  {indicator.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* LEGAL LINKS */}
        <div className="mt-6 text-center space-y-2">
          <p className="text-xs text-muted-foreground">
            Ao fazer login, você concorda com nossos{' '}
            <button
              type="button"
              onClick={() => setModalType('terms')}
              className="text-primary hover:text-primary/80 transition-smooth focus:outline-none focus:underline"
            >
              Termos de Serviço
            </button>
            {' '}e{' '}
            <button
              type="button"
              onClick={() => setModalType('privacy')}
              className="text-primary hover:text-primary/80 transition-smooth focus:outline-none focus:underline"
            >
              Política de Privacidade
            </button>
            .
          </p>
        </div>
      </div>

      {/* MODALS */}
      <LegalModal
        open={modalType === 'privacy'}
        title="Política de Privacidade"
        onClose={() => setModalType(null)}
      >
        <PrivacyPolicy />
      </LegalModal>

      <LegalModal
        open={modalType === 'terms'}
        title="Termos de Serviço"
        onClose={() => setModalType(null)}
      >
        <TermsOfService />
      </LegalModal>
    </>
  );
};

export default TrustIndicators;
